import { HoneycombThemeBase } from '../types';
import { up } from './breakpoints/breakpoints';

export function makeContentMarginStyles(theme: HoneycombThemeBase) {
    return (properties: string | { name: string; coefficient?: number }[], coefficient = 1) => {
        const { keys, values, contentMargins } = theme.breakpoints;
        const propertiesArray = Array.isArray(properties) ? properties : [{ name: properties, coefficient }];
        return keys
            .map((breakpoint) => {
                const value = contentMargins[breakpoint];
                const marginStyles = propertiesArray
                    .map((prop) => {
                        return `${prop.name}: ${value * (prop.coefficient || coefficient)}px;`;
                    })
                    .join('\n');
                // We don't need a media query where the breakpoint value is zero.
                if (values[breakpoint] === 0) {
                    return marginStyles;
                }
                return `${up(theme)(breakpoint)} {
                    ${marginStyles}
                }`;
            })
            .join('\n');
    };
}
